import React from 'react';
import { LayoutRoute } from '../../layout/routes';
import withLoading from '../../helpers/withLoading';

const Accessibility = withLoading(() => import('./'));

const route = <LayoutRoute path="/accessibility" component={Accessibility} />;

export default route;
